export function isImageExtensionValid(imageUrl: string): boolean {
  if (imageUrl === '') return true

  const isExtensionValid =
    imageUrl.includes('.svg') ||
    imageUrl.includes('.jpeg') ||
    imageUrl.includes('.jpg') ||
    imageUrl.includes('.png')

  if (!isExtensionValid) {
    console.log(`Image with url: ${imageUrl} contains invalid extension`)
  }
  return isExtensionValid
}
